import type { FaireProductEntity } from "../../entity_types/product";

export const p_tum68mm6qu: FaireProductEntity = {
  token: "p_tum68mm6qu",
  type: "product",
  name: "Crystal Moon and Stars Open Ring",
  brandToken: "b_y2j497tv82",
  brandName: "The Pretty Jewellery",
  imageUrl:
    "https://cdn.faire.com/fastly/06aa1a0cfd7c52417a964db3b6bba900bcd9e776038e5b8fd810297fdc39c28a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec10fadd9a44c3abf62631926391d62b6f29607c655ffc086417ca1c754e8b0f.jpeg",
    "https://cdn.faire.com/fastly/3123016ac8502a769269d242cf184f03dcad3f9b72926b126b647b5652a4a847.jpeg",
  ],
  priceDollars: 2.77,
  description:
    "Moon and Star Design\n\nShiny crystal\n\nAdjustable Open Ring\n\nGold and Silver 2 options\n\nElectroplating process\n\nSize 2CM",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:11.340Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
